import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { resetPricelistVersion } from '../../reducers/priceListVersionReducer';
import AddPriceListVersionForm from './addPriceListVersionForm';
import { FormType } from '../../constants/constants';

interface IAddPriceListVersionProps {
    classes: any;
    theme: Theme;
    match: any;
    resetPricelistVersion: any;
    priceListId?: number;
    priceListVersionId?: number;
    steps: Array<number>;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetPricelistVersion: () => dispatch(resetPricelistVersion())
});

const mapStoreToProps = (store: RootState, ownProps: IAddPriceListVersionProps) => {
    return {
        priceListId: ownProps.match.params?.priceListId ? Number(ownProps.match.params?.priceListId) : undefined,
        priceListVersionId: ownProps.match.params?.priceListVersionId ? Number(ownProps.match.params?.priceListVersionId) : undefined
    };
};

class AddPriceListVersion extends Component<IAddPriceListVersionProps> {
    componentWillUnmount() {
        const { resetPricelistVersion } = this.props;

        resetPricelistVersion();
    }

    render() {
        const { classes, priceListId, steps, priceListVersionId, type } = this.props;

        return (
            <div>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <AddPriceListVersionForm priceListId={priceListId} steps={steps} priceListVersionId={priceListVersionId} type={type}/>
                    </CardContent>
                </Card>
            </div>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddPriceListVersion));